<template>
  <v-container class="partidos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          icon="mdi-pencil-box-outline"
          sub="Cadastro de partidos"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="partid.usuario"
        />
        <input
          id="partid-id"
          type="hidden"
          v-model="partid.id"
        />
        <input
          id="partid-uuid"
          type="hidden"
          v-model="partid.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="partid.inativar"
              label="Inativar partido?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="5"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="partid.partido"
                  :rules="nameRules"
                  :counter="80"
                  label="Nome do partido"
                  required
                  dense
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="partid.sigla_partido"
                  :rules="siglaRules"
                  :counter="25"
                  label="Sigla do partido"
                  required
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
            class="pt-2"
          >
            <v-card
              class="my-1 mx-auto"
              height="128"
            >
              <v-img
                :src="partid.url_logo"
                class="grey lighten-2"
                contain
                height="128"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="10"
          >
            <v-textarea
              v-model="partid.sobre_partido"
              name="sobre_partido"
              label="Sobre o partido"
              :rules="sobreRules"
              :counter="5000"
              dense
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
            <v-btn
              v-if="codigo"
              color="primary"
              class="mr-4"
              @click="addfoto = true"
            >
              <v-icon left>
                mdi-camera
              </v-icon>
              Add logo
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar partidos
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="partidos"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadPartido(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadPartido(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addfoto"
          transition="dialog-top-transition"
          max-width="800"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Adicionar logo</v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <input
                  :rules="fotorules"
                  show-size
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-camera"
                  label="Logo do partido"
                  v-if="uploadReady"
                  type="file"
                  ref="file"
                  @change="selectFile()"
                >
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="clearUpload"
                >
                  Remover
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  name: 'Partidos',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    codigo: '',
    dialog: false,
    addfoto: false,
    uploadReady: true,
    file: '',
    tabela: 'partidos',
    search: '',
    mode: 'save',
    partido: '',
    sigla_partido: '',
    partid: {},
    partidos: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Sigla', value: 'sigla_partido' },
      { text: 'Partido', value: 'partido' },
      { text: 'Logo', value: 'logo_partido' },
      { text: 'Situação', value: 'inativar' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false,
    nameRules: [
      v => !!v || 'Este campo é obrigatório',
      v => v.length <= 80 || 'O nome do partido deve ter menos de 80 caracteres!'
    ],
    siglaRules: [
      v => !!v || 'Este campo é obrigatório',
      v => v.length <= 25 || 'A sigla do partido deve ter menos de 25 caracteres!'
    ],
    sobreRules: [
      v => v.length <= 5000 || 'O Campo sobre o partido não deve ter mais que 5000 caracteres!'
    ],
    email: '',
    emailRules: [
      v => !!v || 'O E-mail é obrigatório',
      v => /.+@.+/.test(v) || 'O E-mail deve ser válido'
    ],
    fotorules: [
      value => !value || value.size < 500000 || 'O logo não pode ter mais que 500 kB!'
    ]
  }),
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.partid.id ? 'put' : 'post'
      const id = this.partid.id ? `/${this.partid.id}` : ''
      axios[method](`${baseApiUrl}/partidos${id}`, this.partid)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/logo-upload`
      formData.append('id', this.partid.id)
      formData.append('tabela', this.tabela)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    loadPartidos () {
      const url = `${baseApiUrl}/partidos`
      axios.get(url).then(res => {
        this.partidos = res.data
      })
    },
    loadPartido (partid, mode = 'save') {
      this.mode = mode
      this.partid = { ...partid }
      this.codigo = this.partid.id
      this.dialog = false
      this.valid = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = false
      this.mode = 'save'
      this.partid = {}
    },
    loadDialog () {
      this.dialog = true
      this.loadPartidos()
    },
    loadUser () {
      this.partid.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
    this.partid.uuid = uuid.v1()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
